module.exports = __webpack_public_path__ + "img/logo-icon.080a6a24.png";